const handleCloseFormParamUser = {
  confirm: 'Do you really want to exit without saving changes?',
  title: 'UNSAVED CHANGES'
};

export default handleCloseFormParamUser;
